import {Link} from "react-router-dom";

export default function Pagination({page, totalPages, setPage, additionalPages, setAdditionalPages, baseUrl}: {
    page: number,
    totalPages: number,
    setPage: Function,
    additionalPages: number,
    setAdditionalPages: Function,
    baseUrl: string
}) {
    const showMore = () => {
        if (page === totalPages) return
        setPage(page + 1)
        setAdditionalPages(additionalPages + 1)
    }

    const getBaseUrl = () => {
        return baseUrl + (baseUrl.indexOf('?') < 0 ? '?' : '') + 'page='
    }

    const getPageStructure = () => {
        let t1 = false;
        let t2 = false;
        let t3 = false;
        return [
            Array(totalPages).fill(null).map((_, index) => {
                let cpage = index + 1
                if (cpage <= 2 || Math.abs(cpage - page) <= 2 || totalPages - cpage <= 1) {
                    t3 = false
                    return <li key={index}><Link className={cpage === page ? 'active' : ''} to={getBaseUrl() + cpage } >{cpage}</Link></li>
                }
                if (cpage > 2 && Math.abs(cpage - page) > 2 && !t1) {
                    t1 = true
                    t3 = true
                    return <li key={10000}><a className="empty" href="/" onClick={(event) => { event.preventDefault() }}>...</a></li>
                }
                if (cpage + 2 > page && Math.abs(cpage - page) > 2 && !t2 && !t3) {
                    t2 = true
                    return <li key={20000}><a className="empty" href="/" onClick={(event) => { event.preventDefault() }}>...</a></li>
                }
            })
        ]
    }



    return (<>
            <div className={'text-center'}>
                <a className="btn btn-secondary" href="/" onClick={(event) => {
                    event.preventDefault()
                    showMore()
                }}>Показать ещё</a>
            </div>
            <div className="paginator">
                <Link className="paginator__arrow paginator__arrow-prev" to={getBaseUrl() + (page > 1 ? page - 1 : page) } ><i
                    className="ico ico-chevron-left-b"></i></Link>
                <ul>
                    {getPageStructure()}
                    {/*<li><a className="empty" href="">...</a></li>*/}
                </ul>
                <Link className="paginator__arrow paginator__arrow-next"  to={getBaseUrl() + (page < totalPages ? page + 1 : page) } ><i
                    className="ico ico-chevron-right-b"></i></Link>
            </div>
        </>)
}